/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';

type ReadOnlyHeaderSyncType =
  | 'prices'
  | 'mlos'
  | 'closed_for_arrival'
  | 'closed_for_departure';

interface IArgs {
  isBulk?: boolean;
  property?: ModelRegistry['property'];
  syncType: ReadOnlyHeaderSyncType;
}

interface RateReadOnlyHeaderSignature {
  Element: null;

  Args: IArgs;
}

export default class UiRateReadOnlyHeaderComponent extends Component<RateReadOnlyHeaderSignature> {
  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  @cached
  get isReadOnlyAirbnb(): boolean {
    if (this.args.isBulk) {
      return this.propertyRepository
        .peekAll()
        .some((item) => item.airbnbOfficialLink?.isReadOnly);
    }

    return this.args.property?.airbnbOfficialLink?.isReadOnly ?? false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Rate::ReadOnlyHeader': typeof UiRateReadOnlyHeaderComponent;
  }
}
